import React from 'react';
import { View, StyleSheet, Dimensions } from 'react-native';

const { width, height } = Dimensions.get('window');

/**
 * Subtle checker pattern background component
 * @param {boolean} isDarkMode - Whether dark mode is enabled
 * @param {number} opacity - Pattern opacity (default: 0.02 for very subtle)
 * @param {number} squareSize - Size of each square (default: 40)
 * @param {number} [height] - When set, pattern height for scroll context (tall pages). Omit for viewport-fill.
 */
const CheckerPattern = ({ isDarkMode, opacity = 0.02, squareSize = 40, height: heightProp }) => {
  const h = heightProp != null ? heightProp : height;
  const cols = Math.ceil(width / squareSize) + 1;
  const rows = Math.ceil(h / squareSize) + 1;

  const color1 = isDarkMode
    ? `rgba(255,255,255,${opacity})`
    : `rgba(0,0,0,${opacity})`;
  const color2 = 'transparent';

  const squares = [];
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const isEven = (row + col) % 2 === 0;
      squares.push(
        <View
          key={`${row}-${col}`}
          style={{
            position: 'absolute',
            left: col * squareSize,
            top: row * squareSize,
            width: squareSize,
            height: squareSize,
            backgroundColor: isEven ? color1 : color2,
          }}
        />
      );
    }
  }

  const isScrollContext = heightProp != null;
  const rootStyle = isScrollContext
    ? { position: 'absolute', top: 0, left: 0, right: 0, height: heightProp, zIndex: 0 }
    : StyleSheet.absoluteFill;

  return (
    <View style={rootStyle} pointerEvents="none">
      {squares}
    </View>
  );
};

export default CheckerPattern;

